module.exports = __webpack_public_path__ + "static/media/cm-card_FPO.0ee330ad.png";